import SampleReportView from "@/components/samples/SampleReportView";
import { CATALYZE_REPORT } from "@/data/sample-reports";

const CatalyzeSample = () => <SampleReportView report={CATALYZE_REPORT} />;

export default CatalyzeSample;
